// src/hooks/useRequestCount.js

import { useState, useEffect } from 'react';
import { db, auth } from '../config/firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

export const useRequestCount = () => {
  const [count, setCount] = useState(0);
  const currentUser = auth.currentUser;

  useEffect(() => {
    if (!currentUser) return;

    const requestsQuery = query(
      collection(db, 'connection_requests'),
      where('receiverId', '==', currentUser.uid),
      where('status', '==', 'pending')
    );

    const unsubscribe = onSnapshot(requestsQuery, (querySnapshot) => {
      setCount(querySnapshot.size);
    });

    return () => unsubscribe();
  }, [currentUser]);

  return count;
};